import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectDashboard from '@app/views/ProjectDashboard';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectDashboard)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
